export default __webpack_public_path__ + "static/media/allgemein_15.d1c81dac.jpg";